export default __webpack_public_path__ + "static/media/PHQ-9.da5e67d5.pdf";